<div class="md-form md-outline">
  <input
    mdbInput
    [mdbValidate]="true"
    [validateSuccess]="false"
    [formControl]="control"
    name="email"
    type="email"
    [id]="id"
    class="form-control"
    [value]="control.value"
    jhiMarkAsterisk
  />
  <label [for]="id">{{ label }}</label>
  <mdb-error *ngIf="control.invalid && (control.dirty || control.touched)">
    <span *ngIf="control.hasError('email')" jhiTranslate="components.inputs.email.formatError"></span>
    <span *ngIf="control.hasError('required')" jhiTranslate="ERROR.REQUIRED_FIELD"></span>
    <span *ngIf="control.hasError('containInvalidEmail')" jhiTranslate="components.inputs.email.formatErrorMulti"></span>
  </mdb-error>
</div>
